import React from 'react';
import { Link } from 'react-router-dom';
const Header = () => {
          const menu = <>
           <li><Link to="/home">Home</Link></li>
          <li><Link to='/whatWeDo'>What We Do</Link></li>
          <li><Link to="/whatWeAre">Who We Are </Link></li>
          <li><Link to="/beingHere">Being Here</Link></li>
          <li><Link to="/careers">Careers</Link></li>
         
          </>
          return (

                    <div className="navbar bg-dark text-white">
                    <div className="navbar-start">
                        <div className="dropdown">
                            <label tabIndex="0" className="btn btn-ghost lg:hidden">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                            </label>
                            <ul tabIndex="0" className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-blue-100 rounded-box w-52 text-black">
                                {menu}
                            </ul>
                        </div>
                        <a className="btn btn-ghost normal-case text-xl">Instrument</a>
                    </div>
                    <div className="navbar-center hidden lg:flex">
                        <ul className="menu menu-horizontal p-0">
                            {menu}
                        </ul>
                    </div>
                    {/* <div className="navbar-end">
                        <label tabIndex="1" for="dashboard-sidebar" className="btn btn-ghost lg:hidden">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                        </label>
                    </div> */}
                </div>
          );
};

export default Header;